import { useEffect } from 'react'
import { Link } from 'react-router-dom';
import FooterContact from '../../../component/FooterContact';
import HomeVideo2 from '../../../assets/images/banner/banner-1.mp4';

export default function MDR() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Hero */}
            <section className="pad60 box-shadow innertopbanner" style={{ position: 'relative', overflow: 'hidden' }}>
                <div className="overlay-top-left"></div>
                <div className="container">
                    <div className="row align-items-center height100">
                        <div className="col-lg-7 col-md-12">
                            <div className="banner-caption">
                                <div className="breadcrumbs">
                                    <ul>
                                        <li><Link to="/"><span>Home</span></Link><meta content="1" /></li>
                                        <li><i className="icofont-thin-right"></i><span>MDR</span><meta content="2" /></li>
                                    </ul>
                                </div>
                                <div className="prod-section-label">Managed Detection & Response</div>
                                <h1 className="prod-hero-title">Managed <span>Detection &amp; Response</span></h1>
                                <p>Managed Threat Complete offers comprehensive risk and threat protection in one all-inclusive subscription — with 24/7/365 monitoring, end-to-end detection, and immediate response to any potential threat.</p>
                                <div className="button_services mt-4">
                                    <Link to="/contact"><button className="prod-cta-btn">Contact Us &nbsp;<i className="fa fa-arrow-right"></i></button></Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 col-md-12">
                            <div className="banner-mobiles text-center">
                                <img src={require('../../../assets/images/services/products/data-bg-transparant.webp')} alt="MDR" />
                            </div>
                        </div>
                    </div>
                </div>
                <video autoPlay loop muted style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: -1 }}>
                    <source src={HomeVideo2} type="video/mp4" />
                </video>
            </section>

            {/* Overview */}
            <section className="prod-info-section" style={{ background: '#0a0a0a' }}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="prod-info-image">
                                <img src={require('../../../assets/images/services/mdr/mdr.webp')} alt="Managed Threat Complete" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="prod-info-content">
                                <div className="prod-section-label">Managed Threat Complete</div>
                                <h2>Rebalance &amp; Strengthen Your Security Program</h2>
                                <p>A comprehensive solution that rebalances and strengthens your security program by focusing on proactive, strategic initiatives. While you focus on what matters most, we ensure constant vigilance by monitoring your environment 24/7/365, delivering immediate end-to-end detection and response.</p>
                                <p>Now powered by MXDR, enhancing our ability to detect and address security challenges in real-time — giving you peace of mind and confidence in your security posture.</p>
                                <Link to="/contact" className="prod-cta-btn" style={{ marginTop: '12px', display: 'inline-flex' }}>
                                    Talk to Experts <i className="fa fa-arrow-right" style={{ marginLeft: 8 }}></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* 3 Pillars */}
            <section className="prod-highlight-section">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="prod-section-label" style={{ margin: '0 auto 16px' }}>Core Pillars</div>
                        <h2 className="prod-section-title">MXDR <span>Core Capabilities</span></h2>
                    </div>
                    <div className="prod-features-grid" style={{ paddingTop: 0 }}>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon">
                                <img src={require('../../../assets/images/services/mdr/mdr-1.png')} alt="" style={{ width: 28, height: 28, filter: 'brightness(0) invert(1)' }} />
                            </div>
                            <h4>Multi-Vector Attack Visibility</h4>
                            <p>Consolidate insights on abnormal activity across your attack surface by integrating alerts from existing point solutions, enabling quicker and more accurate context correlation.</p>
                            <div className="prod-feature-number">01</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon">
                                <img src={require('../../../assets/images/services/mdr/mdr-3.png')} alt="" style={{ width: 28, height: 28, filter: 'brightness(0) invert(1)' }} />
                            </div>
                            <h4>Defense in Depth</h4>
                            <p>Tailor your service by integrating and layering detections from tools already in your environment, enhancing, accelerating, and streamlining investigations for more effective threat response.</p>
                            <div className="prod-feature-number">02</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon">
                                <img src={require('../../../assets/images/services/mdr/mdr-2.png')} alt="" style={{ width: 28, height: 28, filter: 'brightness(0) invert(1)' }} />
                            </div>
                            <h4>Comprehensive Response</h4>
                            <p>Leveraging context from every available source, the CLOUD MIND SOC swiftly contains malicious activity, preventing it from damaging your environment, business, or brand.</p>
                            <div className="prod-feature-number">03</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Insight Agent Capabilities */}
            <section className="prod-dark-section">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="prod-section-label" style={{ margin: '0 auto 16px' }}>Universal Agent</div>
                        <h2 className="prod-section-title">One Lightweight, <span>Universal Insight Agent</span></h2>
                        <p className="prod-section-sub" style={{ margin: '0 auto' }}>All protection capabilities delivered through a single, efficient agent</p>
                    </div>
                    <div className="prod-features-grid" style={{ paddingTop: 0 }}>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-eye"></i></div>
                            <h4>High Fidelity EDR</h4>
                            <p>Identify and eliminate threats across your endpoint fleet, providing comprehensive protection against advanced attacker tactics and emerging threats.</p>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-database"></i></div>
                            <h4>Rich Endpoint Telemetry &amp; DFIR</h4>
                            <p>A leading open-source DFIR framework that collects, queries, and analyzes endpoint forensics. Trusted worldwide by IR consultants and SOC analysts.</p>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-shield"></i></div>
                            <h4>Managed Next-Gen AV &amp; Ransomware Prevention</h4>
                            <p>Multi-layered prevention that stops attacks before they occur — no extra configuration or agents required.</p>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-search"></i></div>
                            <h4>Proactive Threat Hunting</h4>
                            <p>Threat hunters monitor emerging IOCs and TTPs to conduct hypothesis-driven hunts, identifying hidden threats before they cause damage.</p>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-bolt"></i></div>
                            <h4>Active Response &amp; SOAR</h4>
                            <p>Orchestrate custom actions with unlimited SOAR capabilities, or allow our SOC analysts to promptly contain threats on your behalf.</p>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-bug"></i></div>
                            <h4>Vulnerability Management</h4>
                            <p>Real-time scanning of modern environments to identify vulnerabilities, prioritize risks, and streamline remediation efforts efficiently.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Subscription Tiers */}
            <section className="prod-highlight-section">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="prod-section-label" style={{ margin: '0 auto 16px' }}>Subscription Tiers</div>
                        <h2 className="prod-section-title">Managed Threat <span>Complete Plans</span></h2>
                        <p className="prod-section-sub" style={{ margin: '0 auto' }}>Scalable subscription tiers to meet the evolving needs of your MXDR program</p>
                    </div>
                    <div className="prod-features-grid" style={{ paddingTop: 0 }}>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon">
                                <img src={require('../../../assets/images/services/mdr/mdr-4.png')} alt="" style={{ width: 28, height: 28, filter: 'brightness(0) invert(1)' }} />
                            </div>
                            <h4>Essential</h4>
                            <p>24/7 SOC coverage with comprehensive response, including DFIR capabilities for organizations beginning their MDR journey.</p>
                            <div className="prod-feature-number">01</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon">
                                <img src={require('../../../assets/images/services/mdr/mdr-5.png')} alt="" style={{ width: 28, height: 28, filter: 'brightness(0) invert(1)' }} />
                            </div>
                            <h4>Advanced</h4>
                            <p>Expert guidance and enhanced coverage to outpace evolving threats — ideal for organizations with mature security requirements.</p>
                            <div className="prod-feature-number">02</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon">
                                <img src={require('../../../assets/images/services/mdr/mdr-6.png')} alt="" style={{ width: 28, height: 28, filter: 'brightness(0) invert(1)' }} />
                            </div>
                            <h4>Ultimate</h4>
                            <p>Customized program for security leadership with comprehensive ransomware protection and full-spectrum threat management.</p>
                            <div className="prod-feature-number">03</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA */}
            <section style={{ background: '#0a0a0a', padding: '0 0 80px' }}>
                <div className="container">
                    <div className="prod-cta-banner">
                        <div>
                            <h3>Ready for 24/7 Managed Security?</h3>
                            <p>Let CLOUD MIND's expert SOC team handle threat detection and response while you focus on your business.</p>
                        </div>
                        <Link to="/contact" className="prod-cta-btn">
                            Get Started <i className="fa fa-arrow-right" style={{ marginLeft: 8 }}></i>
                        </Link>
                    </div>
                </div>
            </section>

            <FooterContact />
        </>
    )
}
